import { Platform } from 'react-native';
import * as SplashScreen from 'expo-splash-screen';

// Hold the system splash before React mounts, until navigation or an error is ready.
if( Platform.OS !== 'web' ) {
	SplashScreen.preventAutoHideAsync().catch( () => {
	});
}

export const hideStartupSplash = () => {
	if( Platform.OS !== 'web' ) {
		SplashScreen.hideAsync().catch( () => {
		});
	}
};
